import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgYoutube(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M26.1533 4.24538C21.348 3.91738 10.6453 3.91871 5.84667 4.24538C0.650667 4.60004 0.0386667 7.73871 0 16C0.0386667 24.2467 0.645334 27.3987 5.84667 27.7547C10.6467 28.0814 21.348 28.0827 26.1533 27.7547C31.3493 27.4 31.9613 24.2614 32 16C31.9613 7.75338 31.3547 4.60138 26.1533 4.24538ZM12 21.3334V10.6667L22.6667 15.9907L12 21.3334Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgYoutube);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
